module.exports = __webpack_public_path__ + "img/img2.371ece47.png";